import { LoginService } from './../../../core/services/login.service';
import { Apollo, gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import { Filter } from 'src/app/core/models/filter';
import { combineLatest } from 'rxjs';
import { pluck } from 'rxjs/operators';
const secondHandSuppliesOrdersSubscription = gql`query second_hand_supplies_orders($andList: [second_hand_supplies_orders_bool_exp!], $limit: Int, $offset: Int) {
  second_hand_supplies_orders(where: {_and: $andList}, limit: $limit, offset: $offset, order_by:{order_number: desc}) {
    id
    created_at
    updated_at
    short_id
    total_amount
    tax_amount
    delivery_charge
    estimated_delivery_in_days
    status
    payment_status
    payment_mode
    billing_address
    shipping_address
    online_payment_order_id
    online_payment_transaction_id
    online_payment_signature
    approved_on
    approved_message
    shipped_on
    shipped_message
    delivered_on
    delivered_message
    cancelled_on
    canceled_message
    refunded_on
    refunded_message
    custom_message
    dental_practice_id
    dental_practice {
      id
      name
      email
      phone
    }
    dental_professional_id
    dental_professional {
      id
      name
      email
      phone
    }
    dental_supplier_id
    dental_supplier {
      id
      name
      email
      phone
    }
    account_pay_details
    suppliers_id
    sub_total
    order_number
    invoice
    second_hand_supply_id
    second_hand_supply {
      id
      title
      description
      dental_supplier_id
      dental_professional_id
      dental_practice_id
    }
    second_hand_supplies_order_notes{
      id
      created_at
      updated_at
      second_hand_supplies_order_id
      status
      message
      extra
    }
  }
}`;

const secondHandSuppliesOrdersAggregateSubscription = gql`query second_hand_supplies_orders_aggregate($andList: [second_hand_supplies_orders_bool_exp!]){
  second_hand_supplies_orders_aggregate(where:{_and: $andList}) {
    aggregate {
      count
    }
  }
}`;
@Injectable({
  providedIn: 'root'
})
export class GetSecondHandSuppliesOrdersService {

/* ------------------------------- Constructor ------------------------------ */
  constructor(
  private apollo: Apollo,
  private loginService: LoginService) { }

/* ------------------------------- Get Supply Orders ------------------------------- */
getSecondHandSuppliesOrders(filter: Filter){
  const andList: any =  [];
  if(filter.supplier_name){
 
    andList.push({
      dental_supplier_id: {_eq: filter.supplier_name }
    });
  }

  if(filter.status){
    andList.push({
      status : { _eq: filter.status }
    });
  } else {
    andList.push({
      status : { _neq: 'DRAFT' }
    });
  }

  if(filter.start && filter.end){
    andList.push({
      created_at : {_gte: filter.start, _lte: filter.end},
    });
  }
  const loginData = this.loginService.getLoginData();
  if(loginData.type === 'SUPPLIER'){
      andList.push({
        dental_supplier_id: { _eq: loginData.id}
      })
  }

  if(loginData.type === 'PRACTICE'){
    andList.push({
      dental_practice_id: { _eq: loginData.id}
    })
  }

  if(loginData.type === 'PROFESSIONAL'){
    andList.push({
      dental_professional_id : { _eq: loginData.id}
    })
  }

   const filters: any = filter.filters.filter(single=>{
     return single.value && single.operator && single.value
   }).map(single=>{
     let obj = {};
     let obj1 = {};
     if(single.operator === '_ilike'){
      obj1[single.operator] = `%${single.value}%`;
     } else {
      obj1[single.operator] = single.value;
     }
     obj[single.column.column] = obj1;
     return obj;
  });
  const finalArray = andList.concat(filters);
  return combineLatest([
    this.apollo.use('external').query({
     query: secondHandSuppliesOrdersSubscription,
     fetchPolicy: "network-only",
     variables: {
       andList: finalArray,
       limit: filter.limit,
       offset: filter.offset
     }
    }).pipe(pluck('data', 'second_hand_supplies_orders')),
    this.apollo.use('external').query({
      query: secondHandSuppliesOrdersAggregateSubscription,
      fetchPolicy: "network-only",
      variables: {
        andList: finalArray
      }
    }).pipe(pluck('data', 'second_hand_supplies_orders_aggregate', 'aggregate', 'count'))
  ]);
}
}

